class BtnScroll {

    constructor() {
        this._init();
    }

    _init() {
        const scrollButtons = document.querySelectorAll<HTMLButtonElement>('.btn-scroll');

        const header = document.querySelector<HTMLElement>('header');
        const headerHeight = header ? header.offsetHeight : 0;

        scrollButtons.forEach((button) => {
            button.addEventListener('click', (event) => {

                event.preventDefault();

                const targetId = button.dataset.target;

                if (targetId) {
                    const targetElement = document.getElementById(targetId);

                    if (targetElement) {
                        const targetPosition = targetElement.offsetTop - headerHeight;

                        // Scrolle de manière fluide vers la position calculée
                        window.scrollTo({
                            top: targetPosition,
                            behavior: 'smooth',
                        });
                    }
                }
            });
        });
    }
}

export const btnScroll = new BtnScroll();
